"use client";

import HeaderNav from "@/components/HeaderNav";

interface HeaderWrapperProps {
  promoText: string;
  promoHref: string;
}

export default function HeaderWrapper({ promoText, promoHref }: HeaderWrapperProps) {
  return <HeaderNav promoText={promoText} promoHref={promoHref} />;
}
